import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/outline";

export function FooterTrackOrder() {
  const navigate = useNavigate();
  const [orderNumber, setOrderNumber] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = orderNumber.trim();
    if (!trimmed) return;
    navigate(`/order/track/${encodeURIComponent(trimmed)}`);
  };

  return (
    <form onSubmit={handleSubmit}>
      <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-purple-700/90">
        Track order
      </p>
      <p className="mt-2 text-sm font-semibold text-slate-900">Where&apos;s my package?</p>
      <div className="mt-3 flex gap-2">
        <input
          type="text"
          value={orderNumber}
          onChange={(e) => setOrderNumber(e.target.value)}
          placeholder="Order #"
          aria-label="Order number"
          className="min-w-0 flex-1 rounded-xl border-0 bg-slate-100/80 px-3.5 py-2.5 text-sm text-slate-900 placeholder-slate-400 ring-1 ring-slate-200/80 transition focus:bg-white focus:outline-none focus:ring-2 focus:ring-purple-300/60"
        />
        <button
          type="submit"
          className="inline-flex shrink-0 items-center justify-center rounded-xl bg-slate-900 px-3.5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#3B3B98]"
          aria-label="Track order"
        >
          <ArrowRightIcon className="h-4 w-4" aria-hidden />
        </button>
      </div>
    </form>
  );
}
